/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PropertyInCalendarMapping } from './propertyInCalendarMapping';
import type { PropertyInType } from './propertyInType';

export interface PropertyIn {
  id?: string | null;
  key?: string | null;
  /**
     * @minLength 1
     * @maxLength 80
     */
  name: string;
  type: PropertyInType;
  calendar_mapping?: PropertyInCalendarMapping;
  /** @minimum 0 */
  position: number;
  archived?: boolean;
}
